module.exports = __webpack_public_path__ + "img/cases-brand-yincheng-1.45f46516.jpg";